export const tabs = [
  {
    name: 'Rankings',
    link: '/lists/golf-courses/rankings',
    description:
      'Golf Course Rankings cut in many different ways and highly customisable through filters',
    button: 'Explore',
    icon: 'magnifying-glass',
    buttonClass:
      'bg-indigo-700 w-full rounded-md text-white hover:bg-indigo-900 py-2',
  },
  {
    name: 'Golf Course Info',
    link: '/lists/golf-courses/golf-course-info',
    description:
      'Golf Course Info aims to put 1000 golf course websites on one page for you, to help you research, compare and play more golf.',
    button: 'Explore',
    buttonClass:
      'bg-indigo-700 w-full rounded-md text-white hover:bg-indigo-900 py-2',
    icon: 'laugh-beam',
  },
  {
    name: 'Architects',
    link: '/lists/architects',
    description:
      'Golf course architects ranked by how many courses they designed across UK and Ireland.',
    button: 'Explore',
    icon: 'drafting-compass',
    buttonClass:
      'bg-indigo-700 w-full rounded-md text-white hover:bg-indigo-900 py-2',
  },
  {
    name: 'Club Memberships',
    link: '/lists/golf-clubs/club-memberships',
    description:
      'Club Memberships is aimed at golfers searching for a new golf club, all the membership data you could want in one big list.',
    button: 'Explore',
    buttonClass:
      'bg-indigo-700 w-full rounded-md text-white hover:bg-indigo-900 py-2',
    icon: 'bullseye',
  },
  {
    name: 'Fee Data',
    link: '/lists/golf-courses/green-fee-data',
    description:
      'Filter and chart England green fee data by county and course type, compared to England rankings.',
    button: 'Explore',
    buttonClass:
      'bg-indigo-700 w-full rounded-md text-white hover:bg-indigo-900 py-2',
    icon: 'chart-column',
  },
  {
    name: 'Trip Planner',
    link: '/lists/tools/golf-trips',
    description:
      'Plan your golf trips with our comprehensive trip planner tool.',
    button: 'Explore',
    buttonClass:
      'bg-indigo-700 w-full rounded-md text-white hover:bg-indigo-900 py-2',
    icon: 'route',
  },
  {
    name: 'Random Generator',
    link: '/lists/tools/random-golf-course-generator',
    description:
      'Discover new golf courses with our random course generator.',
    button: 'Explore',
    buttonClass:
      'bg-indigo-700 w-full rounded-md text-white hover:bg-indigo-900 py-2',
    icon: 'dice',
  },
];
